import { useMutation, useQuery } from '@tanstack/react-query'
import useResize from '../../../hooks/useResize'
import { TAGS } from '../../../services/Tags'
import { getCategories } from '../../../services/talents'
import { LIMIT_OF_CHARACTERS, VIEWPORT_LG } from '../../../utils/constants'
import { ErrorMessage } from '@hookform/error-message'
import Button from '../../../components/Button'
import rafiki_icon from '../icons/rafiki.svg'
import { useForm } from 'react-hook-form'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import Loader from '../../../components/Loader'
import confetti from 'canvas-confetti'

import HelperIconTwo from '../../../icons/HelperIconTwo'
import { useTranslation } from 'react-i18next'
import InnerBanner from '../../../components/InnerBanner'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import Toast from '../../../components/Toast/Toast'
import { createChallenge } from '../../../services/HutritClub'

const initialValues = {
  name: '',
  categoryJob: '',
  description: '',
}

const CreateChallenge = () => {
  const { t } = useTranslation()
  // const { id } = useParams()

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    //setValue,
    watch,
  } = useForm({ defaultValues: initialValues })

  const description = watch('description')

  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: categoriesData = [] } = useQuery(
    [TAGS.categories],
    getCategories
  )

  const { mutate: createChallengeMutate, isLoading: isLoadingCreateChallenge } =
    useMutation(['create-challenge'], createChallenge, {
      onSuccess: ({ status }) => {
        if (status === 200) {
          confetti()
          reset()
          Toast({
            title: 'Reto creado exitosamente',
          })
          return
        }
        if (status !== 200) {
          Toast({
            title: <strong>{t('error_in_the_system')}</strong>,
            icon: 'error',
            confirmButtonColor: 'Red',
          })
          return
        }
      },
    })

  const onSubmit = (data) => {
    createChallengeMutate(data)
  }

  return (
    <DashboardWrapper>
      <div
        className={`${
          viewportSize[0] <= VIEWPORT_LG ? '' : 'stepper-container'
        } d-flex flex-lg-row flex-column-reverse justify-content-center align-items-center p-lg-0 p-3`}
      >
        <div className="w-100">
          <InnerBanner
            className="mb-3"
            before="Retos de Hutrit Club"
            beforeRoute={PRIVATE_ROUTES.list_of_challenges}
            text="Nuevo reto"
          />
          <h2
            className="text-bg-brand d-none d-lg-inline-block"
            style={{
              fontWeight: 800,
              marginTop: isMobile ? '' : '90px',
            }}
          >
            {t('what_profiles_are_you_looking_for')}
          </h2>
          <form
            className="border rounded p-4 bg-white"
            style={{
              marginTop: isMobile ? '' : '40px',
              width: isMobile ? '100%' : '85%',
            }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div>
              <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
                <span>Nombre del reto</span>
                <HelperIconTwo />
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Asigna un nombre al reto"
                {...register('name', {
                  required: t('this_field_is_required'),
                })}
              />
              <ErrorMessage
                errors={errors}
                name="name"
                render={({ message }) => (
                  <span className="text-danger font-small">{message}</span>
                )}
              />
            </div>
            <div
              className="sector-company"
              style={{ marginTop: isMobile ? '17px' : '32px' }}
            >
              <label className="form-label text-on-bg-primary">
                Tipo de perfil
              </label>
              <select
                id="category-select"
                className="form-control"
                {...register('categoryJob', {
                  required: t('this_field_is_required'),
                })}
              >
                <option disabled value="" className="text-on-bg-primary">
                  Escoge el perfil al que va dirigido el reto
                </option>
                {categoriesData?.map(({ id, name }) => (
                  <option key={id} value={id}>
                    {name}
                  </option>
                ))}
              </select>
              <ErrorMessage
                errors={errors}
                name="categoryJob"
                render={({ message }) => (
                  <span className="text-danger font-small">{message}</span>
                )}
              />
            </div>

            <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
              <label className="form-label text-on-bg-primary">
                Descripción del reto
              </label>
              <textarea
                {...register('description', {
                  required: t('this_field_is_required'),
                  validate: (value) => {
                    const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
                    if (urlRegex.test(value)) {
                      return t('no_external_links_allowed_in_this_field')
                    }

                    if (description?.length >= LIMIT_OF_CHARACTERS) {
                      return `${description?.length}/${LIMIT_OF_CHARACTERS}`
                    }
                  },
                })}
                rows="5"
                className="form-control"
                id="sector"
              ></textarea>
              <ErrorMessage
                errors={errors}
                name="description"
                render={({ message }) => (
                  <span className="text-danger font-small">{message}</span>
                )}
              />
            </div>
            <div className="d-flex justify-content-center justify-content-lg-start mt-4 mb-4">
              <Button
                disabled={isLoadingCreateChallenge}
                className="btn-bg-CTA-primary"
                type="submit"
              >
                {isLoadingCreateChallenge ? <Loader /> : 'Guardar y crear reto'}
              </Button>
            </div>
          </form>
        </div>
        <div className="d-flex flex-column justify-content-end align-items-center w-100">
          <img src={rafiki_icon} />
          <span
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? 'w-100' : 'w-50'
            } text-on-bg-secondary text-center mt-4`}
          >
            Crea un reto atractivo para que los talentos juniors demuestren sus
            habilidades y puedas evaluar sus aptitudes antes de hacer una
            oferta.
          </span>
        </div>
      </div>
    </DashboardWrapper>
  )
}

export default CreateChallenge
